import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'
import SearchButton from './SearchButton'
import { useRouter } from 'next/router'
import { breakpoint } from '../layout/styles'

const languages = [{
  name: 'EN',
  locale: 'en-CA',
  flag: '/images/ca-flag.svg',
  resetOnLocales: ['en-US'],
  homepage: '/en-CA'
}, {
  name: 'FR',
  locale: 'fr',
  flag: '/images/ca-flag.svg',
  resetOnLocales: ['en-US'],
  homepage: '/fr'
}, {
  name: 'EN',
  locale: 'en-US',
  flag: '/images/us-flag.svg',
  resetOnLocales: ['en-CA', 'fr'],
  homepage: '/'
}]

const Topbar = ({ searchOpen, setSearchOpen, setMenuOpen }: any) => {
  const router = useRouter()
  const [lang, setLang] = React.useState(languages.find((lang: any) => lang.locale === router.locale || 'en-US'))

  React.useEffect(() => {
    setLang(languages.find((lang: any) => lang.locale === router.locale))
  }, [router.locale])

  // router.asPath includes the locale prefix (e.g. /en-CA/recipes/...) which
  // must be stripped before passing to <Link locale=...> to avoid double-prefixing.
  const localelessPath = (() => {
    const prefix = `/${router.locale}`
    return router.asPath.startsWith(prefix)
      ? router.asPath.slice(prefix.length) || '/'
      : router.asPath
  })()

  return (
    <Container>
      {/* <div>
        <a href="#newsletter" onClick={() => setMenuOpen(false)}>
          Subscribe
        </a>
      </div> */}
      <div>
        <a target="_blank" href="https://salesportal.highlinerfs.com/Account/LogOn?ReturnUrl=%2f" onClick={() => setMenuOpen(false)}>
          Gateway
        </a>
      </div>
      <Dropdown>
        {lang &&
          <span><span><Flag src={lang.flag} alt={lang.locale} />{lang.name}</span><img src="/images/down.svg" alt="menu" /></span>}
        <ul>
          {languages.map((language: any) =>
            <li key={language.locale}>
              <Link href={language.resetOnLocales.includes(router.locale) ? language.homepage : localelessPath} locale={language.locale}>
                <a>
                  <Flag src={language.flag} alt={language.locale} />{language.name}
                </a>
              </Link>
            </li>)}
        </ul>
      </Dropdown>
      <SearchButton {...{ searchOpen, setSearchOpen }} />
    </Container>
  )
}

export default Topbar

export const Container = styled.div<any>`
  display: none;
  justify-content: center;
  position: relative;
  align-items: center;
  flex-direction: column;
  @media ${breakpoint.desktop} {
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    margin-bottom: 36px;
    margin-right: 48px;
    top: -20px;
    display: flex;
  }
  a {
    font-family: GothamMedium, "Open Sans", sans-serif;
    font-size: 1rem;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 700;
    @media ${breakpoint.desktop} {
      text-decoration: none;
      font-size: 12px;
      text-transform: uppercase;
      color: #000;
      font-weight: bold;
      margin: 0;
    }
  }
  & > div {
    padding: 1rem 1.5rem;
    border-bottom: 1px #666 solid;
    width: 100%;
    background: #EDF7FA;
    @media ${breakpoint.desktop} {
      background: transparent;
      width: auto;
      margin-right: 20px;
      padding: 0;
      border-bottom: 0;
      &:last-child {
        margin-left: 20px;
      }
    }
    &:first-child {
      order: 2;
      border-bottom: 0;
      background: transparent;
      @media ${breakpoint.desktop} {
        order: inherit;
      }
      a {
        border: 1.5px #000 solid;
        text-align: center;
        padding: 10px 0;
        @media ${breakpoint.desktop} {
          text-align: inherit;
          padding: 5px 10px;
        }
      }
    }
  }
  img {
    max-width: 18px;
  }
`

const Flag = styled.img<any>`
  width: 100%;
  height: 100%;
  display: inline-block;
  min-width: 34px;
  min-height: 17px;
`

const Dropdown = styled.div<any>`
  position: relative;
  text-decoration: none;
  font-size: 12px;
  text-transform: uppercase;
  color: #000;
  font-weight: bold;
  line-height: 16px;

  > span {

    line-height: 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media ${breakpoint.desktop} {
      justify-content: flex-start;
    }
    img:first-child {
      margin-right: 10px;
    }

    @media ${breakpoint.desktop} {
      img:last-child {
        margin-left: 16px;
      }
    }
  }

  > span > span {
    display: flex;
    align-items: center;
  }

  ul, li {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  ul {
    display: none;
    margin-top: 10px;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    @media ${breakpoint.desktop} {
      margin-top: 0;
      position: absolute;
      margin-left: 0;
      margin-right: 0;
      margin-left: -10px;
      width: calc(100% + 20px);
    }
    z-index: 1;
    padding-top: 10px;

    li:last-child {
      margin-bottom: -1rem;
      @media ${breakpoint.desktop} {
        margin-bottom: 0;
      }
    }
  }

  @media ${breakpoint.desktop} {
    li {

      & > a {
        border-left: 1.5px #000 solid;
        border-right: 1.5px #000 solid;
      }
      
      &:first-child > a {
        border-top: 1.5px #000 solid;
      }

      &:last-child > a {
        border-bottom: 1.5px #000 solid;
      }

    }
  }

  a {
    border-top: 1px #666 solid;
    padding: 1rem 1.5rem;
    @media ${breakpoint.desktop} {
      background: #fff;
      border-top: inherit;
      padding: 10px 10px;
      margin-left: 0;
      margin-right: 0;
    }
    white-space: nowrap;
    display: flex;
    align-items: center;
    width: 100%;
    &:hover {
      background: #000;
      color: #fff;
    }

    img:first-child {
      margin-right: 10px;
    }
  }

  &:hover > ul {
    display: inherit;
  }
`
